<template>
  <div
    v-if="value"
    class="modal-mask"
    @click.self="close"
    role="dialog"
    aria-modal="true"
    aria-labelledby="privacy-policy-title"
  >
    <div class="modal-content-container">
      <div class="modal-header">
        <button
          @click="close"
          class="modal-close-btn"
          aria-label="Fechar política de privacidade"
        >
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="modal-content">
        <div class="title-container">
          <h2 id="privacy-policy-title">Política de Privacidade</h2>
        </div>
        <div class="content-container">
          <section>
            <p>
              O Club da Cotação desenvolve aplicativos como serviços comerciais. Esta
              página é usada para informar os visitantes sobre nossas políticas com a
              coleta, uso e divulgação de Informações Pessoais, caso alguém decida usar
              nosso Serviço. Se você optar por usar nosso Serviço, concorda com a coleta e
              uso de informações em relação a esta política. As Informações Pessoais que
              coletamos são usadas para fornecer e melhorar o Serviço. Não usaremos nem
              compartilharemos suas informações com ninguém, exceto conforme descrito
              nesta Política de Privacidade. Os termos usados nesta Política de
              Privacidade têm os mesmos significados que em nossos Termos e Condições, a
              menos que definido de outra forma nesta Política de Privacidade.
            </p>
          </section>

          <section>
            <h3>Coleta e Uso de Informações</h3>
            <p>
              Para uma melhor experiência, ao usar nosso Serviço, podemos solicitar que
              você nos forneça certas informações pessoalmente identificáveis, incluindo,
              mas não se limitando a login, senha. As informações que solicitamos serão
              retidas por nós e usadas conforme descrito nesta política de privacidade. O
              aplicativo usa serviços de terceiros que podem coletar informações usadas
              para identificá-lo.
            </p>
          </section>

          <section>
            <h3>Dados de Registro</h3>
            <p>
              Queremos esclarecer que não coletamos dados de registro durante o uso do
              nosso Serviço. Não rastreamos informações como endereço do Protocolo de
              Internet ("IP") do seu dispositivo, nome do dispositivo, versão do sistema
              operacional, ou qualquer outra informação de registro.
            </p>
          </section>

          <section>
            <h3>Cookies</h3>
            <p>
              Cookies são arquivos com uma pequena quantidade de dados que são comumente
              usados como identificadores únicos anônimos. Eles são enviados para o seu
              navegador a partir dos sites que você visita e são armazenados na memória
              interna do seu dispositivo. Este Serviço não usa explicitamente esses
              "cookies". No entanto, o aplicativo pode usar códigos e bibliotecas de
              terceiros que usam "cookies" para coletar informações e melhorar seus
              serviços. Você tem a opção de aceitar ou recusar esses cookies e saber
              quando um cookie está sendo enviado para o seu dispositivo. Se você optar
              por recusar nossos cookies, pode ser que não consiga usar algumas partes
              deste Serviço.
            </p>
          </section>

          <section>
            <h3>Provedores de Serviços</h3>
            <p>
              Podemos empregar empresas e indivíduos terceirizados devido aos seguintes
              motivos: <br/>
              Para facilitar nosso Serviço; Para fornecer o Serviço em nosso
              nome; <br/>
              Para realizar serviços relacionados ao Serviço; <br/>
              Para nos ajudar a analisar como nosso Serviço é usado. <br/>
              Queremos informar aos usuários deste
              Serviço que essas terceiras partes não têm acesso às suas Informações
              Pessoais.<br/>
               Apenas realizam as tarefas atribuídas a eles em nosso nome.
            </p>
          </section>

          <section>
            <h3>Segurança</h3>
            <p>
              Valorizamos sua confiança em nos fornecer suas Informações Pessoais e, portanto, estamos nos esforçando para usar meios comercialmente aceitáveis para protegê-las. Mas lembre-se de que nenhum método de transmissão pela internet ou método de armazenamento eletrônico é 100% seguro e confiável, e não podemos garantir sua segurança absoluta.
            </p>
          </section>

          <section>
            <h3>Privacidade de Crianças</h3>
            <p>
              Estes Serviços não se destinam a menores de 13 anos. Não coletamos intencionalmente informações pessoalmente identificáveis de crianças menores de 13 anos. No caso de descobrirmos que uma criança com menos de 13 anos nos forneceu informações pessoais, excluiremos imediatamente essas informações de nossos servidores. Se você é pai ou responsável e tem conhecimento de que seu filho nos forneceu informações pessoais, entre em contato conosco para que possamos tomar as medidas necessárias. Alterações a Esta Política de Privacidade Podemos atualizar nossa Política de Privacidade de tempos em tempos. Portanto, recomendamos que você revise esta página periodicamente para verificar quaisquer alterações. Notificaremos você sobre quaisquer alterações publicando a nova Política de Privacidade nesta página.
            </p>
          </section>

          <section>
            <h3>Entre em Contato</h3>
            <p>
              Se você tiver alguma dúvida ou sugestão sobre nossa Política de Privacidade, não hesite em entrar em contato conosco em
              <a href="mailto:suporte@clubdacotacao.com.br"
                >suporte@clubdacotacao.com.br</a
              >.
            </p>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyModal",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden";
        this.$nextTick(() => {
          const closeBtn = this.$el.querySelector(".modal-close-btn");
          if (closeBtn) closeBtn.focus();
        });
      } else {
        document.body.style.overflow = "auto";
      }
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/commons/_variables";

.modal-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(13, 13, 13, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  font-family: inherit;
}

.modal-content-container {
  background-color: white;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
}

.modal-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #e9ecef;
  }

  .material-icons {
    font-size: 1.5rem;
    color: #6c757d;
  }
}

.modal-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 2rem 2rem;
}

.title-container {
  text-align: center;
  margin: 2rem 0;

  h2 {
    font-size: 2rem;
    font-weight: 600;
    margin: 0;
  }
}

.content-container {
  section {
    margin-bottom: 2rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h3 {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 1.5rem 0 1rem 0;
  }

  p {
    line-height: 1.6;
    color: #495057;
    margin: 0 0 1rem 0;
    text-align: justify;
  }

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .modal-content-container {
    width: 95%;
    margin: 1rem;
  }

  .modal-content {
    padding: 0 1rem 1rem;
  }

  .title-container h2 {
    font-size: 1.5rem;
  }

  .content-container {
    h3 {
      font-size: 1.1rem;
    }

    p {
      font-size: 0.9rem;
    }
  }
}

.modal-content::-webkit-scrollbar {
  width: 6px;
}

.modal-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.modal-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
